export const rates = {
  standard: {
    fee: 0.029,
    transaction: 30,
  },
  express: {
    fee: 0.0245,
    transaction: 30,
  },
  payout: {
    fee: 0.0025,
    transaction: 0,
  },
  radar: {
    fee: 0,
    transaction: 5,
  },
};
